<div class="tt-wrapper bg-white dark:bg-coal-700">
  <div class="tt-header">
    <div class="tt-header-left">
      <label
        class="tt-search-box"
        [class.tt-search-box--active]="searchField.value"
      >
        <i class="ki-filled ki-magnifier tt-search-icon"></i>
        <input
          placeholder="Search"
          #searchField
          [value]="searchInput || ''"
          (input)="onKeyUpSearch(searchField.value)"
          type="text"
          class="tt-search-input"
        />
        <button
          #search
          *ngIf="searchField.value"
          type="button"
          class="tt-search-clear"
          (click)="clearSearch(searchField)"
        >
          ×
        </button>
      </label>
    </div>
    <div class="tt-header-right">
      <button
        *ngIf="isWriteAccess"
        class="btn btn-primary btn-brand-primary btn-sm text-nowrap cursor-pointer"
        (click)="openAddModal(undefined, 'invite')"
      >
        Invite
      </button>
      <button
        *ngIf="isWriteAccess"
        class="btn btn-primary btn-brand-primary btn-sm text-nowrap cursor-pointer"
        (click)="openAddModal(undefined, 'add')"
      >
        <i class="ki-filled ki-plus-squared"></i>
        Add User
      </button>
      <button
        class="btn btn-sm btn-primary btn-brand-primary"
        (click)="reloadData()"
      >
        <ng-container *ngIf="!isReloading">
          <i class="ki-filled ki-arrows-circle text-xl"></i>
          Reload
        </ng-container>
        <ng-container *ngIf="isReloading">
          <div class="loader"></div>
          Loading...
        </ng-container>
      </button>
      <!-- Filter Dropdown -->
      <div class="relative inline-block" #dropdownContainer>
        <div class="inline-block">
          <button
            cdkOverlayOrigin
            #trigger="cdkOverlayOrigin"
            [ngClass]="{
              'btn-light': !hasActiveDropdownFilters,
              'btn-light-primary': hasActiveDropdownFilters,
            }"
            class="btn btn-sm text-gray-700 px-4 py-2 rounded flex items-center gap-2 relative"
            (click)="toggleFilterDropdown()"
          >
            <i class="ki-filled ki-setting-4"></i>
            Filter

            <!-- 🔵 Blue Dot -->
            <span
              style="top: -6px; right: -6px"
              *ngIf="hasActiveDropdownFilters"
              class="absolute top-0 right-1 w-3 h-3 bg-blue rounded-full"
            ></span>
          </button>

          <!-- 🔵 Blue Dot -->
          <span
            *ngIf="hasActiveDropdownFilters"
            class="top-1 right-1 w-2.5 h-2.5 bg-info rounded-full"
          ></span>
        </div>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="isFilterDropdownOpen"
          [cdkConnectedOverlayPositions]="dropdownPositions"
          (overlayOutsideClick)="closeDropdown()"
        >
          <div
            style="z-index: 99999; width: 500px"
            class="bg-white dark:bg-coal-500 border rounded-xl max-w-[90vw] mt-1 shadow-lg"
          >
            <div class="px-6 py-3">
              <div class="fs-5 text-gray-900 font-semibold text-base">
                Filter
              </div>
            </div>
            <div class="separator border-gray-200 mt-1"></div>
            <div class="p-0 m-0">
              <app-modal-renderer
                *ngIf="activeModalContext"
                #modalRendererRef
                [nodeId]="activeModalContext?.nodeId"
                (header)="setModalTitle($event)"
                (closeModal)="closeDropdown()"
                [activeModalContext]="activeModalContext"
                (clearAll)="clearAll($event)"
                (loadData)="loadData($event.formId, $event.options)"
                (onFilterApplied)="onFilterApplied($event)"
                [isFilterApply]="isFilterApply"
                [labelAbove]="labelAbove"
                [disabledBtn]="disabledBtn"
                [twoGridColumn]="true"
              ></app-modal-renderer>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="tt-scroll" #tableBodyContainer (scroll)="onTableScroll()">
    <table #myTable class="tt-table">
      <thead class="tt-thead">
        <tr class="tt-head-row" *ngIf="columns?.length">
          <ng-container *ngFor="let fieldName of columns">
            <th class="tt-th" *ngIf="fieldName !== 'action'">
              <span
                class="tt-col-label flex items-center gap-1 w-max"
                [ngClass]="
                  isSortable(fieldName) ? 'cursor-pointer' : 'cursor-default'
                "
                (click)="
                  fieldName && isSortable(fieldName) && toggleSort(fieldName)
                "
              >
                {{ getColumnDisplayName(fieldName) }}
                <span
                  class="sort-icons flex flex-col -space-y-1 ml-1"
                  *ngIf="fieldName && isSortable(fieldName)"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    [class.active]="currentSort[fieldName] === 'asc'"
                    (click)="onSort(fieldName, 'asc'); $event.stopPropagation()"
                  >
                    <polyline points="6 15 12 9 18 15"></polyline>
                  </svg>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    [class.active]="currentSort[fieldName] === 'desc'"
                    (click)="
                      onSort(fieldName, 'desc'); $event.stopPropagation()
                    "
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </span>
            </th>
          </ng-container>
          <th class="tt-th text-center" *ngIf="isWriteAccess">
            <span class="tt-col-label">Action</span>
          </th>
        </tr>

        <!-- Skeleton Header when columns are not yet loaded -->
        <tr class="tt-head-row" *ngIf="isLoader && (!columns || columns.length === 0)">
          <th
            *ngFor="let col of defaultSkeletonCols; let idx = index"
            class="tt-th"
          >
            <div
              class="sk-box h-3.5 rounded"
              [style.width.px]="idx === 0 ? 120 : idx === 1 ? 80 : idx === 2 ? 90 : 80"
            ></div>
          </th>
          <th class="tt-th text-center" *ngIf="isWriteAccess">
            <div class="sk-box h-3.5 w-12 rounded mx-auto"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- ── SKELETON ── -->
        <ng-container *ngIf="isLoader">
          <!-- When columns are known -->
          <ng-container *ngIf="columns?.length">
            <tr class="tt-row" *ngFor="let row of [1, 2, 3, 4, 5, 6, 7, 8]">
              <ng-container *ngFor="let fieldName of columns">
                <td class="tt-td" *ngIf="fieldName !== 'action'">
                  <ng-container [ngSwitch]="fieldName">
                    <!-- Name column with avatar and 2 text lines -->
                    <div *ngSwitchCase="'name'" class="flex items-center gap-3">
                      <div class="sk-box w-9 h-9 rounded-full shrink-0"></div>
                      <div class="min-w-0 flex flex-col gap-1.5">
                        <div class="sk-box h-3.5 w-28 rounded"></div>
                        <div class="sk-box h-2.5 w-36 rounded"></div>
                      </div>
                    </div>

                    <!-- Badges -->
                    <div
                      *ngSwitchCase="'status'"
                      class="sk-box w-20 h-5 rounded-full"
                    ></div>
                    <div
                      *ngSwitchCase="'inviteStatus'"
                      class="sk-box w-20 h-5 rounded-full"
                    ></div>
                    <div
                      *ngSwitchCase="'invite'"
                      class="sk-box w-20 h-5 rounded-full"
                    ></div>

                    <!-- Default cell -->
                    <div
                      *ngSwitchDefault
                      class="sk-box h-3 rounded"
                      [style.width.px]="getSkeletonWidth(fieldName)"
                    ></div>
                  </ng-container>
                </td>
              </ng-container>
              <td class="tt-td text-center" *ngIf="isWriteAccess">
                <div class="sk-box w-6 h-6 rounded mx-auto"></div>
              </td>
            </tr>
          </ng-container>

          <!-- Fallback when columns are still loading -->
          <ng-container *ngIf="!columns || columns.length === 0">
            <tr class="tt-row" *ngFor="let row of [1, 2, 3, 4, 5, 6, 7, 8]">
              <td class="tt-td">
                <div class="flex items-center gap-3">
                  <div class="sk-box w-9 h-9 rounded-full shrink-0"></div>
                  <div class="min-w-0 flex flex-col gap-1.5">
                    <div class="sk-box h-3.5 w-28 rounded"></div>
                    <div class="sk-box h-2.5 w-36 rounded"></div>
                  </div>
                </div>
              </td>
              <td class="tt-td">
                <div class="sk-box h-3 w-24 rounded"></div>
              </td>
              <td class="tt-td">
                <div class="sk-box w-20 h-5 rounded-full"></div>
              </td>
              <td class="tt-td">
                <div class="sk-box w-20 h-5 rounded-full"></div>
              </td>
              <td class="tt-td text-center" *ngIf="isWriteAccess">
                <div class="sk-box w-6 h-6 rounded mx-auto"></div>
              </td>
            </tr>
          </ng-container>
        </ng-container>

        <tr
          class="noDataContainer"
          *ngIf="fieldsData?.length == 0 && !isLoader"
        >
          <td
            [attr.colspan]="
              (columnsData?.formCollection?.columns?.length || 0) + 1
            "
            class="!p-0"
          >
            <div
              class="flex flex-col items-center justify-center w-full"
              style="min-height: calc(100vh - 280px)"
            >
              <app-no-data-view
                title="No Users Found"
                description="There are no users matching your current filters or search."
                imagePath="./assets/media/icons/empty-users-small.svg"
                imageHeight="64px"
              >
              </app-no-data-view>
            </div>
          </td>
        </tr>

        <ng-container *ngIf="!isLoader">
          <tr
            class="tt-row group"
            *ngFor="let item of fieldsData; let i = index"
          >
            <ng-container *ngFor="let fieldName of columns">
              <td class="tt-td" *ngIf="fieldName !== 'action'">
                <ng-container *ngIf="fieldName === 'name'; else defaultCell">
                  <div class="flex items-center gap-3">
                    <img
                      [src]="getAssigneePhotoUrl(item)"
                      alt="Profile Photo"
                      class="tt-avatar object-cover"
                      (error)="handleImageError($event)"
                    />
                    <div class="min-w-0 flex flex-col">
                      <div class="tt-task-name line-clamp-1">
                        {{ item.name }}
                      </div>
                      <div class="tt-due-relative">{{ item.email }}</div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #defaultCell>
                  <ng-container
                    *ngIf="
                      fieldName != 'email' &&
                      fieldName != 'name' &&
                      fieldName != 'status' &&
                      fieldName != 'inviteStatus' &&
                      fieldName != 'invite'
                    "
                  >
                    <span
                      class="text-2sm font-medium text-gray-800 dark:text-[#94a3b8]"
                      >{{ getCellValue(item, fieldName) }}</span
                    >
                  </ng-container>

                  <!-- Invite Status Badge -->
                  <ng-container
                    *ngIf="fieldName == 'inviteStatus' || fieldName == 'invite'"
                  >
                    <span
                      class="custom-badge badge badge-sm badge-outline rounded-full text-nowrap"
                      [ngClass]="{
                        'badge-success':
                          getCellValue(item, fieldName) == 'ACCEPTED',
                        'badge-info': getCellValue(item, fieldName) == 'SENT',
                        'badge-warning':
                          getCellValue(item, fieldName) == 'PENDING',
                      }"
                    >
                      {{ getCellValue(item, fieldName) }}
                    </span>
                  </ng-container>

                  <ng-container *ngIf="fieldName == 'status'">
                    <span
                      class="custom-badge badge badge-sm badge-outline rounded-full text-nowrap"
                      [ngClass]="{
                        'dark:badge-secondary badge-secondary':
                          item.status == 'IN-ACTIVE',
                        'badge-verified dark:badge-verified':
                          item.status == 'INVITED',
                        'badge-success': item.status == 'ACTIVE',
                        'badge-audited dark:badge-audited':
                          item.status == 'ARCHIVED',
                        'badge-danger': item.status == 'SUSPENDED',
                      }"
                    >
                      {{ item.status }}
                    </span>
                  </ng-container>
                </ng-template>
              </td>
            </ng-container>

            <td class="tt-td text-center relative" *ngIf="isWriteAccess">
              <ng-container *ngIf="shouldShowNA(item)">
                <span class="text-sm font-semibold text-gray-400">NA</span>
              </ng-container>
              <div
                *ngIf="!shouldShowNA(item)"
                class="dropdown"
                [class.show]="isDropdownOpen(item._id)"
                [class.open-above]="shouldOpenAbove(item._id)"
              >
                <button
                  #dropdownButton
                  class="tt-menu-btn"
                  [ngClass]="{ 'opacity-100': isDropdownOpen(item._id) }"
                  type="button"
                  (click)="toggleDropdown(item._id, $event)"
                  [attr.data-id]="item._id"
                >
                  <span></span><span></span><span></span>
                </button>
                <div
                  *ngIf="isDropdownOpen(item._id)"
                  #dropdownMenu
                  [attr.data-menu]="item._id"
                  class="tt-dropdown"
                >
                  <button
                    class="tt-dropdown-item"
                    (click)="updateUserStatus(item, 'EDIT')"
                  >
                    Edit
                  </button>
                  <button
                    class="tt-dropdown-item"
                    *ngIf="
                      (item.status == 'IN-ACTIVE' ||
                        item.status == 'ARCHIVED' ||
                        item.status == 'SUSPENDED') &&
                      item.email !== 'support@eciso.ai'
                    "
                    (click)="updateUserStatus(item, 'ACTIVE')"
                  >
                    Activate
                  </button>
                  <button
                    class="tt-dropdown-item"
                    *ngIf="
                      (item.status == 'ACTIVE' ||
                        item.status == 'ARCHIVED' ||
                        item.status == 'SUSPENDED') &&
                      item.invite == 'SENT' &&
                      item.email !== 'support@eciso.ai'
                    "
                    (click)="updateUserStatus(item, 'REINVITE')"
                  >
                    Reinvite
                  </button>
                  <button
                    class="tt-dropdown-item"
                    *ngIf="item.status == 'ACTIVE'"
                    (click)="updateUserStatus(item, 'IN-ACTIVE')"
                  >
                    Inactive
                  </button>
                  <button
                    class="tt-dropdown-item"
                    *ngIf="
                      item.status == 'ACTIVE' &&
                      item.email !== 'support@eciso.ai'
                    "
                    (click)="updateUserStatus(item, 'SUSPEND')"
                  >
                    Suspend
                  </button>
                  <button
                    class="tt-dropdown-item"
                    *ngIf="
                      (item.status == 'ACTIVE' ||
                        item.status == 'IN-ACTIVE' ||
                        item.status == 'SUSPENDED') &&
                      item.email !== 'support@eciso.ai'
                    "
                    (click)="updateUserStatus(item, 'ARCHIVE')"
                  >
                    Archive
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div
    class="tto-footer rounded-b-xl"
    *ngIf="fieldsData?.length > 0 && !isLoader"
  >
    <!-- Left: page size + total -->
    <div class="tto-footer-left">
      <div class="tto-page-size">
        <select
          class="tto-page-size-select dark:bg-coal-700 dark:text-gray-200"
          (change)="onPerPageChange($event)"
        >
          <option
            class="dark:bg-coal-700 dark:text-gray-200"
            [selected]="currentLimit == '10'"
            value="10"
          >
            10 / page
          </option>
          <option
            class="dark:bg-coal-700 dark:text-gray-200"
            [selected]="currentLimit == '20'"
            value="20"
          >
            20 / page
          </option>
          <option
            class="dark:bg-coal-700 dark:text-gray-200"
            [selected]="currentLimit == '50'"
            value="50"
          >
            50 / page
          </option>
          <option
            class="dark:bg-coal-700 dark:text-gray-200"
            [selected]="currentLimit == '100'"
            value="100"
          >
            100 / page
          </option>
        </select>
        <svg
          class="tto-select-chevron"
          width="10"
          height="6"
          viewBox="0 0 10 6"
        >
          <path
            d="M1 1l4 4 4-4"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <span class="tto-total">Total {{ totalCount }} records</span>
    </div>

    <!-- Right: pagination -->
    <div class="tto-footer-right" *ngIf="totalPages > 1">
      <div class="tto-pagination">
        <button
          class="tto-page-btn"
          [disabled]="currentPage === 1"
          (click)="previousPage()"
        >
          <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
            <path
              d="M5 1L1 5l4 4"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <ng-container *ngFor="let page of pageNumbers">
          <button
            *ngIf="page !== '...'"
            class="tto-page-btn"
            [class.active]="page === currentPage"
            (click)="changePage(page)"
          >
            {{ page }}
          </button>
          <span *ngIf="page === '...'" class="tto-page-dots">…</span>
        </ng-container>

        <button
          class="tto-page-btn"
          [disabled]="currentPage === totalPages"
          (click)="nextPage()"
        >
          <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
            <path
              d="M1 1l4 4-4 4"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  id="confirm_modal"
>
  <div
    class="modal-content break-words my-5 sm:rounded-lg shadow-lg max-w-[600px] w-full bg-white dark:bg-coal-500"
  >
    <div class="modal-header flex justify-between items-center p-4">
      <span class="font-semibold text-base ms-2 card-title">{{
        activeModalContext?.clickedButton === "EDIT"
          ? "Edit Role"
          : formData?.formCollection?.formName
      }}</span>
    </div>

    <div class="modal-body gap-5 p-4">
      <form
        *ngIf="saveForm"
        [formGroup]="saveForm"
        (keydown.enter)="onEnter($event)"
      >
        <div class="px-5 mb-2">
          <input type="submit" hidden />
          <ng-container *ngFor="let field of formFields">
            <app-placeholder-with-text
              *ngIf="field.componentId == 'noDataTypeTwo'"
              [formGroup]="saveForm"
              [fields]="field"
              [activeModalContext]="activeModalContext"
            ></app-placeholder-with-text>
          </ng-container>
        </div>
        <div
          class="modal-footer pt-4 px-4 flex justify-end border-t border-gray-100 dark:border-gray-700 gap-3"
        >
          <button
            type="button"
            class="btn btn-sm btn-secondary cancel-modal-btn"
            (click)="closeModal()"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-sm btn-primary btn-brand-primary"
            (click)="updateStatus()"
          >
            {{
              activeModalContext?.clickedButton === "EDIT"
                ? "Save"
                : footerFields[0]?.displayName
            }}
            <div class="loader" *ngIf="isLoading"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<app-open-modal
  *ngIf="addModalContext && isModalOpen(addModalContext.nodeId)"
  [context]="addModalContext"
  (close)="closeAddModal(addModalContext.nodeId)"
  (formSaved)="onFormSaved($event)"
  [disableBackdropClick]="true"
>
</app-open-modal>
